// Keep these in sync with the NewTariffSurveySearch .sections_and_tabs value!
export const routes = {
  global: {
    slug: "global",
    tabs: {
      change_map: {
        slug: "change-over-time-map"
      },
      change_over_time: {
        slug: "change-over-time"
      },
      breakdown: {
        slug: "breakdown"
      },
      histogram: {
        slug: "histogram"
      }
    }
  },
  cities: {
    slug: "cities",
    tabs: {
      comparison: {
        slug: "comparison"
      },
      breakdown: {
        slug: "breakdown"
      },
      histogram: {
        slug: "histogram"
      }
    }
  },
  all_data: {
    slug: "all-data",
    tabs: {}
  },
  about: {
    slug: "about",
    tabs: {}
  }
};

export const makeSlug = function (firstPart, secondPart) {
  const base = "/" + routes[firstPart].slug;

  if (!secondPart) { return base; }

  return base + "/" + routes[firstPart].tabs[secondPart].slug;
};

export const makeChildSlug = function (firstPart, secondPart) {
  if (!secondPart) { return; }

  return "/" + routes[firstPart].tabs[secondPart].slug;
};

export const currentTabIs = function (state, tabSlug) {
  return state.router.params.tab == tabSlug;
};
